// extracted by mini-css-extract-plugin
module.exports = {"title":"SocialAuth_title__fIinr","row":"SocialAuth_row__5uUIA","link":"SocialAuth_link__q9W4z","loading":"SocialAuth_loading__x1yRl","active":"SocialAuth_active__wNxiC"};